import clsx from 'clsx'

/**
 * Collectia surface card (DESIGN_GUIDELINES §5): white surface on the off-white
 * page, soft shadow, rounded (--radius-card), generous padding. Not part of the
 * Catalyst kit — added for Collectia and reused across screens.
 */
export function Card({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) {
  return (
    <div
      {...props}
      className={clsx(className, 'rounded-card bg-surface p-6 shadow-sm ring-1 ring-zinc-950/5')}
    />
  )
}

export function CardTitle({ className, ...props }: React.ComponentPropsWithoutRef<'h3'>) {
  return <h3 {...props} className={clsx(className, 'font-heading text-h3 font-bold text-text-strong')} />
}
